export default `
  query customer {
    customer {
      date_of_birth
      default_billing
      default_shipping
      id
      email
      firstname
      is_subscribed
      is_b2b
      lastname
      middlename
      prefix
      suffix
      taxvat
      custom_attributes(attributeCodes: [
        "partnership_type"
      ]){
        code
        ... on AttributeSelectedOptions {
          selected_options {
            value
          }
        }
      }
      addresses {
        city
        country_code
        default_billing
        default_shipping
        extension_attributes {
          attribute_code
          value
        }
        custom_attributesV2(attributeCodes: [
          "company_email", "invoice_email"
        ]){
          code
          ... on AttributeValue {
            value
          }
        }
        firstname
        id
        lastname
        postcode
        prefix
        region {
          region_code
          region_id
          region
        }
        street
        suffix
        telephone
        vat_id
      }
      is_subscribed
      approved_by {
        name
        email
        phone
      } 
    }
  }
`;
